import {Center, Popover, useDisclose, VStack} from "@hosttools/frontend";
import type {Listing} from "@hosttools/frontend/models/listing";
import type React from "react";
import {memo} from "react";
import {useHistory} from "react-router-dom";

import PricingMenu from "@/client/components/Header/PricingMenu";
import TopNavMenuItem from "@/client/components/Header/TopNavMenuItem";
import Text from "@/client/components/Text";

type Props = {
    visibleListings: Listing[];
    isActive?: boolean;
};

const NavPricing: React.FC<Props> = ({visibleListings, isActive}) => {
    const history = useHistory();
    const {isOpen, onOpen, onClose} = useDisclose();

    if (visibleListings.length > 1) {
        return (
            <Popover
                hasArrow
                className="p-0"
                isOpen={isOpen}
                trigger={
                    <TopNavMenuItem
                        icon="chevron-down"
                        isActive={isActive}
                        testID="btn-pricing-menu"
                        to={onOpen}
                    >
                        Pricing
                    </TopNavMenuItem>
                }
                onClose={onClose}
            >
                <VStack className="max-w-96 max-h-96 overflow-y-auto pt-5">
                    <PricingMenu onPress={onClose} />
                </VStack>
            </Popover>
        );
    }
    if (visibleListings.length === 1) {
        return (
            <TopNavMenuItem
                isActive={isActive}
                testID="btn-pricing-menu"
                to={() => history.push(`/pricing/${visibleListings[0]._id}`)}
            >
                Pricing
            </TopNavMenuItem>
        );
    }

    return (
        <Popover
            hasArrow
            isOpen={isOpen}
            trigger={
                <TopNavMenuItem
                    icon="chevron-down"
                    isActive={isActive}
                    testID="btn-pricing-menu"
                    to={onOpen}
                >
                    Pricing
                </TopNavMenuItem>
            }
            onClose={onClose}
        >
            <Center>
                <Text variant="sm">Nothing Found</Text>
            </Center>
        </Popover>
    );
};

export default memo(NavPricing);
